<template>
	<div id="imei-thing" class="w-100 text-center pb-3">

		<template v-if="showCompatibility == false">
	
			<h5 class="tab-title text-center p-2">
				Verificación por IMEI
			</h5>

			<p class="text-center p-2">
				¿Tienes duda si tu equipo es compatible con la red de <b>Clave Verde</b>?<br />
				¡Sigue las siguientes instrucciones para saberlo!.
			</p>
	
			<b-row class="m-2">
				<b-col cols="4">
					<h5>Paso 1</h5>
					<p>
						Ingresa a la marcación<br />en tu teléfono.
					</p>
				</b-col>
	
				<b-col cols="4">
					<h5>Paso 2</h5>
					<p>
						Digita <strong>*#06#</strong><br />
						para obtener tu IMEI.
					</p>
				</b-col>
	
				<b-col cols="4">
					<h5>Paso 3</h5>
					<p>
						Ingresa tu IMEI en el<br />
						formulario de abajo.
					</p>
				</b-col>
			</b-row>
	
			<b-row>
				<b-col cols="12">
					<b-form class="p-2" @submit="onSubmit">
		
						<b-form-group  label="Ingresa tu IMEI:">
							<b-form-input class="text-center limit-width" v-model="form.imei" type="number" required />
						</b-form-group>
		
						<b-button v-if="!isProcessing" type="submit" class="btn-send btn-s2">Consultar</b-button>
		
						<b-button v-else disabled class="btn-send btn-s2">Consultando...</b-button>
		
					</b-form>
				</b-col>
			</b-row>

		</template>

		<div class="mt-4" v-else>

			<div v-if="altanResponse.deviceFeatures.band28 == 'NO'">
				<h5 class="tab-title">
					El {{ altanResponse.deviceFeatures.brand }}
					{{ altanResponse.deviceFeatures.model }} no es compatible con nuestra red
				</h5>
			</div>

			<div v-else-if="altanResponse.deviceFeatures.volteCapable == 'NO'">
				<h5 class="tab-title">
					El {{ altanResponse.deviceFeatures.brand }}
					{{ altanResponse.deviceFeatures.model }} es parcialmente compatible con 
					la red de <b>Clave Verde</b>®.
				</h5>
			</div>

			<div v-else>
				<h5 class="tab-title">
					El {{ altanResponse.deviceFeatures.brand }}
					{{ altanResponse.deviceFeatures.model }} es compatible con la red de 
					<b>Clave Verde</b>®.
				</h5>
			</div>

			<b-row class="mt-4 mb-4 fixed-breaks">

				<b-col>
					<h3 class="mb-4">IMEI</h3>
					<b-table :items="objectToArray(altanResponse.imei)" />
				</b-col>

				<b-col>
					<h3 class="mb-4">Características de hardware</h3>
					<b-table :items="objectToArray(altanResponse.deviceFeatures)" />
				</b-col>

			</b-row>


			<p class="f-w-500">
				Verifica si otro equipo puede gozar de los beneficios que ofrece la red.
			</p>

			<p class="mt-3">
				<a class="link-orange f-w-600" @click="showCompatibility = false;">
					<i class="fas fa-mobile-android-alt"></i> 
					Verificar nuevo dispositivo
				</a>
			</p>

		</div>

	</div>
</template>

<script>
import axios from "axios";
import _ from "lodash";

import { mixedMSG } from "@/utils.js";

export default {
	data() {
		return {
			showCompatibility: false,
			isProcessing: false,
			altanResponse: {

				imei: {
					imei: null,
					homologated: null,
					blocked: null,
					sub_category: null,
					soportaESIM: null,
				},

				deviceFeatures: {
					volteCapable: null,
					band28: null,
					model: null,
					brand: null,
				},

			},

			form: {
				imei: "",
			},
		};
	},

	methods: {
		objectToArray(obj) {
			let keyReLabel = (keyName) => {
				let renamers = {
					imei: "IMEI",
					homologated: "Homologado",
					blocked: "Bloqueado",
					sub_category: "Sub categoría",
					soportaESIM: "Soporta eSIM",
					volteCapable: "Soporta VolTE",
					band28: "Banda 28",
					model: "Modelo",
					brand: "Marca",
				}
				return renamers[keyName]
			};
			return _.map(obj, (Dato, Valor) => {
				Valor = keyReLabel(Valor)
				return { Valor, Dato };
			});
		},
		async onSubmit(event) {
			event.preventDefault();

			// IS PROCESSING
			this.isProcessing = true;

			// TRYING
			try {
				let response = await axios.get("index.php?r=api/consulta/imei/" + this.form.imei);

				// RESPONSE STATUS
				if (response.status) {
					this.form.imei = "";
					this.showCompatibility = true;
					this.altanResponse = response.data;
				}

				// SHOW MSG
				mixedMSG(response.status, response.msg, response.class);

			} catch (e) {
				console.error(e);
			}

			// IS NOT
			this.isProcessing = false;
		},
	},

	components: {
		// successCheckmark2Component,
		// errorCheckmarkComponent,
	},
};
</script>

<style lang="scss">
@import '@/scss/app.scss';

#imei-thing {
	.fixed-breaks {
		@media screen and (max-width: 991px) {
			// background-color: green;
			flex-flow: column;
		}
	}
	table {
		thead {
			th {
				&:first-child {
					width: 40%;
				}
			}
		}
		tbody {
			td {
				&:first-child {
					text-align: right;
					font-weight: 600;
					color: $primary;
				}
				&:last-child {
					text-align: left;
				}
			}
		}
	}
	input.text-center {
		font-weight: bold;
		font-size: 1.25em;
		color: $accent;
	}
	input.limit-width {
		max-width: 450px;
	}
}
</style>